import { FetchClient } from '@cvent/fetch';
import LOG from '../../../logger.js';
const DEFAULT_CVENT_ANALYTICS_URL = 'https://io.cvent.com/factor';
const DEFAULT_FLUSH_MS = 1000;
const DEFAULT_QUEUE_LIMIT = 5;
class CventAnalyticsClient {
    constructor({ url = DEFAULT_CVENT_ANALYTICS_URL, maxItems = DEFAULT_QUEUE_LIMIT, flushMs = DEFAULT_FLUSH_MS, disabled = false, keepalive = false, onError }) {
        this.queue = [];
        this.url = url;
        this.disabled = disabled;
        this.maxItems = maxItems;
        this.flushMs = flushMs;
        this.onError = onError;
        this.client = new FetchClient({
            init: {
                mode: 'cors',
                cache: 'no-cache',
                keepalive,
                headers: {
                    'Content-Type': 'application/json'
                }
            },
            preRequest: [this.middleware()]
        });
    }
    get shouldQueue() {
        return this.maxItems > 0;
    }
    middleware() {
        return async (url, init) => {
            if (!this.url) {
                throw new Error('cvent-analytics not initialized. url is undefined');
            }
            return [url, init];
        };
    }
    enqueue(payload, callback) {
        if (Array.isArray(payload)) {
            payload.forEach(item => this.enqueue(item, callback));
        }
        else {
            this.queue.push([payload, callback]);
        }
        if (this.queue.length > this.maxItems) {
            clearTimeout(this.flushTimeout);
            this.flushTimeout = undefined;
            this.flush();
            return;
        }
        if (!this.flushTimeout) {
            this.flushTimeout = setTimeout(() => {
                this.flushTimeout = undefined;
                this.flush();
            }, this.flushMs);
        }
    }
    flush() {
        this.batch([...this.queue]);
        this.queue.length = 0;
    }
    async track(payload, callback) {
        if (this.disabled) {
            LOG.info('cvent-analytics', 'track', payload);
            callback();
            return;
        }
        try {
            await this.client.post(`${this.url}/dai/v1/fact`, JSON.stringify(payload));
            callback();
        }
        catch (err) {
            if (this.onError && err instanceof Error) {
                this.onError(err);
            }
            else {
                throw err;
            }
        }
    }
    async batch(payloads) {
        if (this.disabled) {
            payloads.forEach(([data, callback]) => {
                LOG.info('cvent-analytics', 'batch', data);
                callback();
            });
            return;
        }
        try {
            const facts = payloads.map(([data]) => data);
            const response = await this.client.post(`${this.url}/dai/v1/batch_facts`, JSON.stringify(facts));
            if (!response.ok) {
                throw new Error(`Failed sending batch to cvent-analytics: ${response.statusText}`);
            }
        }
        catch (err) {
            if (this.onError && err instanceof Error) {
                this.onError(err);
            }
            else {
                throw err;
            }
        }
        finally {
            payloads.forEach(([, callback]) => callback());
        }
    }
    send(data, providedCallback) {
        const callback = providedCallback ||
            (() => {
                LOG.debug(`tracked`, data);
            });
        if (this.shouldQueue) {
            this.enqueue(data, callback);
        }
        else {
            this.track(data, callback);
        }
    }
}
export default CventAnalyticsClient;
//# sourceMappingURL=CventAnalyticsClient.js.map